import {
    AfterViewInit,
    ChangeDetectorRef,
    Component, Inject,
    Input,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewChild
} from '@angular/core';
import {NodeComponent} from "@app/workflow-common/diagram-view2/node/node.component";
import {SidepanelModalService} from "@app/sidepanel/services/sidepanel-modal.service";
import {DiagramService} from "@app/workflow-common/diagram-view2/services/diagram.service";
import {TranslateService} from "@ngx-translate/core";
import {TriggerDatasetService} from "@app/workflow-common/services/trigger-dataset.service";
import {combineLatest, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {INodeOptions} from "@app/workflow-common/diagram-view2/models/node.model";
import {
    TriggerConditionPanelComponent
} from "@app/workflow-common/diagram-view2/panels/trigger-condition-panel/trigger-condition-panel.component";
import {InitialBlockInterface} from "@app/workflow-common/services/DagSourceModel";
import {WorkflowhttpService} from "@app/workflow-common/services/workflowhttp.service";
import {animate, keyframes, style, transition, trigger} from "@angular/animations";
import {DOCUMENT} from "@angular/common";

@Component({
  selector: 'app-node-root',
  templateUrl: './node-root.component.html',
  styles: [],
  animations: [
    trigger('highlightNodeAdded', [
        transition('*=>on', animate('3000ms', keyframes([
            style({backgroundColor: '#ffffff', offset: 0} ),
            style({backgroundColor: '#DAFDD7', offset: 0.1} ),
            style({backgroundColor: '#ffffff', offset: 1} ),
        ])))
    ])
  ],
})
export class NodeRootComponent extends NodeComponent implements OnInit,  OnDestroy, AfterViewInit {

    nodeTemplate: TemplateRef<any>;
    private unsubscribeAll: Subject<any> = new Subject<any>();
    nodeOptions: INodeOptions;
    nodeSubTitlePrefix: string = '';
    onHighlight: string = '';
    isAuditHightlight: boolean = false;


    @Input() rules: any[];
    @Input() dependentId: string = '';
    @Input() conditions: string = 'AND';
    @Input() mainObjectName: string = '';

    @ViewChild('cs_initializer') initializerTemplate: TemplateRef<any>;
    constructor(
        protected modalService: SidepanelModalService,
        protected changeDetection: ChangeDetectorRef,
        protected diagramService: DiagramService,
        protected translateService: TranslateService,
        protected triggerService: TriggerDatasetService,
        @Inject('confirmationBoxHelper') protected confirmationBoxHelper,
        @Inject('$scope') protected ajsScope,
        protected workflowHttp: WorkflowhttpService,
        @Inject(DOCUMENT) protected document: Document,
    ) {
      super(modalService, changeDetection, diagramService, translateService, triggerService, confirmationBoxHelper, ajsScope, workflowHttp, document);
    }

  ngOnInit() {
      this.isRoot = this.id == 'cs_initializer';
      this.block_name = this.name;
      this.operatorsDisplayText = this.triggerService.getOperatorsDisplayText();
      combineLatest(
          this.diagramService.diagram$,
      )
      .pipe( takeUntil(this.unsubscribeAll))
      .subscribe( ([nodeParams] ) => {
          if(nodeParams) {
              const {nodeOptions} = nodeParams;
              this.nodeOptions = nodeOptions;
              this.viewMode = this.nodeOptions.viewMode;
              if(this.viewMode == 'history' && this.nodeOptions.tasksStatus && this.nodeOptions.tasksStatus.hasOwnProperty(this.id)) {
                  this.taskStatus = this.nodeOptions.tasksStatus[this.id];
              }
              if(this.viewMode == 'audit') {
                  this.isAuditHightlight = this.nodeOptions.audit['taskId'].includes(this.id);
              }
              const { metaData } = this.nodeOptions;
              if(metaData['screenName'] == 'customForm') {
                  this.nodeSubTitlePrefix = 'Custom form is ';
              }
              else {
                  this.nodeSubTitlePrefix='';
              }
          }
      });
  }

    showTriggerPanel(isEdit: boolean = false) {
        const { metaData, objectName, workflowType } = this.nodeOptions;
        const { fields } = metaData;
        const initialState = {
            title: this.translateService.instant('Trigger conditions'),
            fields,
            objectName,
            workflowType,
            dagSourceModel: this.dagSourceModel,
            isEdit,
            rules: this.rules
        };
        const triggerPanelRef = this.showHideSidePanel(initialState, TriggerConditionPanelComponent);
        triggerPanelRef.content.onClose.subscribe( (data: {
            action:string,
            node?: InitialBlockInterface,
            isEdit?: boolean
        }) => {
            if(data.action == 'close') {

            }
            else if(data.action == 'add' || data.action == 'edit') {
                if(data.action == 'add') {
                    this.dagSourceModel.addTask( data['node'] );
                }
                else {
                    this.dagSourceModel.updateRootTask( data['node'] );
                }
                const { id, rules, conditions, parentId, block_name, name, mainObject, dependentId } = data['node'];
                this.id = id;
                this.rules = rules;
                this.conditions = conditions;
                this.parentId = parentId;
                this.name = name;
                this.blockId = this.id;
                this.mainObjectName = mainObject;
                this.diagramService.isNodeUpdated();
                this.diagramService.autoSave(true);
                this.onHighlight='on';
            }
            triggerPanelRef.hide();
        });
    }

    editNode() {
        if(this.viewMode == 'history') {
            this.showHistoryTaskStatus();
        }
        else if(this.viewMode == 'form') {
            this.showTriggerPanel(true);
        }
    }

    ngOnDestroy(): void {
        this.unsubscribeAll.next(null);
        this.unsubscribeAll.complete();
        this.unsubscribe();
    }

/*    ngAfterViewInit(): void {
        this.changeDetection.detectChanges();
    }*/

}
